import { Pipe, PipeTransform } from '@angular/core';
import { ExchangeMoneyFormatter, ExchangeRates } from '../exchange-formatter/exchange-formatter';

@Pipe({ name: 'multiMoney', pure: true })
export class MultiMoneyPipe implements PipeTransform {
  constructor(private exchangeMoneyFormatter: ExchangeMoneyFormatter) {}

  /**
   * Formatea el valor según cada ExchangeRate recibido y concatena los resultados.
   * El panel define exchangeRates (ej. solo COP, solo USD, o COP y USD); el pipe formatea
   * cada uno y genera el texto con todos los formatos unidos por ' / '.
   */
  transform(value: number, title: string | null | undefined, exchangeRates: ExchangeRates[]): string {
    const rates = exchangeRates || [];
    this.exchangeMoneyFormatter.refreshExchangeRates(rates);

    const parts = rates
      .map((rate) => this.exchangeMoneyFormatter.format(value, rate.currencyCode))
      .filter((s) => s !== '');

    const formatted = parts.length ? parts.join(' / ') : '—';
    if (title == null || title === '') {
      return formatted;
    }
    return `${title}: ${formatted}`;
  }
}
